<mat-list>
    <mat-list-item class="view-mat-list-item">
        <span matListItemTitle>
            Nume
        </span>
        <span matListItemLine>
            {{ spouse.nume + ' ' + spouse.prenume }}
        </span>
    </mat-list-item>

    <mat-list-item class="view-mat-list-item">
        <span matListItemTitle>
            Info CI/BI
        </span>
        <span matListItemLine>
            {{ (spouse.ci_serie && spouse.ci_numar)
            ? (spouse.ci_serie + ' ' + spouse.ci_numar) : '-' }}
        </span>
    </mat-list-item>

    <mat-list-item class="view-mat-list-item">
        <span matListItemTitle>
            CNP
        </span>
        <span matListItemLine>
            {{ spouse.cnp || '-' }}
        </span>
    </mat-list-item>

    <mat-list-item class="view-mat-list-item">
        <span matListItemTitle>
            Nr. pașaport
        </span>
        <span matListItemLine>
            {{ spouse.nr_pasaport || '-' }}
        </span>
    </mat-list-item>

    <mat-list-item class="view-mat-list-item">
        <span matListItemTitle>
            Cetățenie
        </span>
        <span matListItemLine>
            {{ spouse.cetatenie || '-' }}
        </span>
    </mat-list-item>

    <mat-list-item class="view-mat-list-item">
        <span matListItemTitle>
            Competențe limba romană
        </span>
        <span matListItemLine>
            {{ spouse.competenta_limba ? 'DA' : 'NU' }}
        </span>
    </mat-list-item>

    <mat-list-item class="view-mat-list-item">
        <span matListItemTitle>
            Nume dorit
        </span>
        <span matListItemLine>
            {{ spouse.nume_dorit || '-' }}
        </span>
    </mat-list-item>

    <mat-list-item class="view-mat-list-item" *ngIf="spouse.tara">
        <span matListItemTitle>
            Țară
        </span>
        <span matListItemLine>
            {{ spouse.tara }}
        </span>
    </mat-list-item>

    <mat-list-item class="view-mat-list-item" *ngIf="spouse.stat_provincie">
        <span matListItemTitle>
            Stat/provincie
        </span>
        <span matListItemLine>
            {{ spouse.stat_provincie }}
        </span>
    </mat-list-item>

    <mat-list-item class="view-mat-list-item" *ngIf="spouse.judet">
        <span matListItemTitle>
            Județ
        </span>
        <span matListItemLine>
            {{ spouse.judet }}
        </span>
    </mat-list-item>

    <mat-list-item class="view-mat-list-item">
        <span matListItemTitle>
            Oraș
        </span>
        <span matListItemLine>
            {{ spouse.oras || '-' }}
        </span>
    </mat-list-item>

    <mat-list-item class="view-mat-list-item">
        <span matListItemTitle>
            Adresă
        </span>
        <span matListItemLine>
            {{ spouse.adresa_text || '-' }}
        </span>
    </mat-list-item>

    <mat-list-item class="view-mat-list-item">
        <span matListItemTitle>
            Observații
        </span>
        <span matListItemLine>
            {{ spouse.observatii || '-' }}
        </span>
    </mat-list-item>
</mat-list>